import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';
import * as types from './types';

const INITIAL_STATE = {
    esperandoSolicitacao: false,
    error: false,
    error_elo: false,
    mensagem: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case types.DECLARACAO_ATIVIDADE_IMPRESSAO_SOLICITADA:
            return { ...state, esperandoSolicitacao: true, error: false, error_elo: false, mensagem: '' };

        case types.DECLARACAO_ATIVIDADE_IMPRESSAO_RECEBIDA:
            return { ...state, esperandoSolicitacao: false, mensagem: 'sucesso' };

        case types.DECLARACAO_ATIVIDADE_ERRO_ELO:
            return { ...state, esperandoSolicitacao: false, error_elo: true }
            
        case types.DECLARACAO_ATIVIDADE_ERRO_IMPRESSAO_RECEBIDO:
            return { ...state, esperandoSolicitacao: false, mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR, error: true };

        case types.DECLARACAO_ATIVIDADE_LIMPAR_MENSAGEM:
            return { ...state, esperandoSolicitacao: false, error: false, error_elo: false, mensagem: ''};

        case types.DECLARACAO_ATIVIDADE_NAO_ENCONTRADA:
            return {...state, esperandoSolicitacao: false, mensagem: 'not_found', error_elo: false}

        default:
            return state;
    }
}
